import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from './http-headers.service';
import { Urls } from '../utilities/urls.component';
import { CurrencyDTO } from '../models/CurrencyDTO';
import { ResponseDTO } from '../models/ResponseDTO';

@Injectable()
export class UtilService {

  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }

  getCurrencyList() {
    var url: string = Urls.API_ENDPOINT + Urls.UTIL.currency;
    return this.http.get<CurrencyDTO>(url, this.headers.getCommonHttpHeaders());
  }
  getCountryList() {
    var url: string = Urls.API_ENDPOINT + Urls.UTIL.country;
    return this.http.get<ResponseDTO>(url, this.headers.getCommonHttpHeaders());
  }
  getTimezoneList() {
    var url: string = Urls.API_ENDPOINT + Urls.UTIL.timezone;
    return this.http.get<ResponseDTO>(url, this.headers.getCommonHttpHeaders());
  }

  // registerUser(request: CreateUserRequestDTO) {
  //   var url: string = Urls.API_ENDPOINT + Urls.USER.registerUser;
  //   return this.http.post<UserResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  // }

}
